import { DashboardLayout } from "components/DashboardLayout";
import { Header } from "components/DesignSystem/Header/Header";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { AllReportsContent } from "./AllReportsContent";
import { useCurrentGroup } from "hooks/useCurrentGroup";
import { usePageTitle } from "hooks/usePageTitle";

export const AllReports = () => {
  usePageTitle("Exports");
  const entityId = useCurrentEntityId();
  const { uuid: groupId } = useCurrentGroup();

  return (
    <DashboardLayout header={<Header title="Exports" v2 />}>
      <AllReportsContent entityId={entityId} groupId={groupId!} />
    </DashboardLayout>
  );
};
